class ServicesArea extends HTMLElement {
  constructor() {
    super();
    this.ServiceImages = this.querySelectorAll('.services-featured-image');
    const inputField = this.querySelectorAll('.services-dropdown__checkbox');
    inputField.forEach((ele, index) => {
      ele.checked = index === 0;
      ele.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.ServicesImages(index);
          inputField.forEach((input, i) => {
            if (i !== index) {
              input.checked = false;
            }
          });
        }
        //  else {
        //   this.ServiceImages.forEach((ele) => {
        //     ele.style.opacity = '0';
        //     ele.style.position = 'absolute';
        //     setTimeout(() => {
        //       ele.style.display = 'none';
        //     }, 500);
        //   });
        // }
      });
    });
    this.ServicesImages(0);
  }

  ServicesImages(index) {
    this.ServiceImages.forEach((ele, i) => {
      ele.style.opacity = '0';
      if (i === index) {
        ele.style.transform = 'translateY(0)';
        ele.style.display = 'block';
        ele.style.position = 'relative';
      } else {
        ele.style.position = 'absolute';
        ele.style.transform = 'translateY(-300px)';
        ele.style.display = 'none';
      }
    });
    setTimeout(() => {
      this.ServiceImages[index].style.opacity = '1';
    }, 300);
  }
}

customElements.define('services-area', ServicesArea);
